import { authzServiceName } from '@shared/services/authz/constants';

export enum AppStoreMenuName {
  about = 'About',
  home = 'Home',
  appStore = 'App Store',
  myApps = 'Apps',
  myModels = 'Models',
  myInstances = 'App Instances',
  myAiEngines = 'AI Engines',
  platformUsage = 'Platform Usage',
  collaborate = 'Collaborate',
  featureStore = 'Feature Store',
  adminMarketplaceApps = 'Admin Marketplace Apps',
  adminApps = 'Admin Apps',
  adminCenter = 'Cloud Environment',
  adminInstances = 'Admin App Instances',
  adminAiEngines = 'Admin AI Engines',
  aiEngineSettings = 'AI Engines Settings',
  kernelSettings = 'Kernel Settings',
  secureStoreOAuthClients = 'OAuth Clients',
  secureStoreSecrets = 'Secrets',
  documentation = 'Documentation',
  cliApiAccess = 'CLI & API Access',
  apiAccess = 'API Access',
  license = 'License',
  news = `What's New`,
  logout = 'Logout',
  drive = 'Drive',
}

export const serviceNames = {
  appstore: 'services/appstore',
  aiem: 'services/engine-manager',
  featurestore: `services/feature-store-rest-api`,
  mlops: 'services/mlops-api',
  mlopsLegacy: 'services/mlops',
  steam: 'services/steam',
  telemetry: 'services/telemetry-server',
  orchestrator: 'services/orchestrator',
  notebookAPI: 'services/notebook-api',
  secureStore: 'services/secure-store',
  authz: authzServiceName,
  mcAdminCenter: 'services/mcac-backend-service',
  auditTrail: 'services/audit-trail',
  stsDrive: 'services/drive-sts',
  userDrive: 'services/userdrive',
  workspaceDrive: 'services/workspacedrive',
  modelHub: 'services/modelhub',
  sessionServer: 'services/sessionserver',
  workflows: 'services/workflows',
  h2oGpte: 'services/h2ogpte',
  hacAssistant: 'services/hac-assistant-service',
};

export const clientNames = {
  appstore: 'clients/appstore',
  platform: 'clients/platform',
};
